import 'intl';
import 'intl/locale-data/jsonp/en';
import 'core-js/es';
import 'mutation-observer';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './redux/reducer';
import './index.less';
import { Router } from './util/router/router';
import { IntlProvider } from './util/intl';
// import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';

ReactDOM.render(
  <Provider store={store}>
    <IntlProvider>
      <div className="main">
        <Router />
      </div>
    </IntlProvider>
  </Provider>,
  document.getElementById('roots'),
);
// registerServiceWorker();
unregister();
